import React, {Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {ComparisonSourceTypes, InputTypes} from "../reducers/store";
import {updateSource, setSelectedOnly} from "../reducers/files";

class CompareText extends Component {
  constructor (props) {
    super(props);
    this.state = {
      errors: {}
     
    }
  }
  
  //dodanie textu
  onInputTextChange = e => {
    const {updateSource, sourceType} = this.props;
    updateSource({
      inputType: InputTypes.TEXT,
      content: e.target.value,
      sourceType
    });
  }
  
  
  //zmiana typu pliku 
  onInputTypeChange = e => {
    const {updateSource, sourceType} = this.props;
    console.log("text");
    updateSource({
      inputType: e.target.value,
      sourceType
    });
  }
  
 
  
  render () {
    const {sourceType, label, source, processing, inProgress, secondLabel,textorfile} = this.props;
    const {inputType, content} = source;
    
    if(sourceType ==="ORGINAL")
      {if(textorfile==="text")
    {console.log("text")}else{console.log("file")}}
    
    /*do wstawienia warunki
  ||(((textorfile === null)||!(textorfile === "TEXT"))&&(secondLabel === "true"))
 {secondLabel === "true" ? [textorfile === null ? [<div><span className="wp-block-button__link has-background jsa-demo-drop-step">2</span>Dodaj tekst lub plik w lewym oknie </div>]: 
          [textorfile === "TEXT" ? 'Wpisz tekst ': 'Dodaj plik']]:[<div><span className="wp-block-button__link has-background jsa-demo-drop-step">1</span>Twoja praca / sparafrazowany tekst </div>] 

    */
  
    return <div key={2}>
    
      
        <label className="text-label">   
         {secondLabel === "true" ? [<div><span className="wp-block-button__link has-background jsa-demo-drop-step">2</span> Tekst, z którego korzystałeś / raport JSA</div>]: 
          [<div><span className="wp-block-button__link has-background jsa-demo-drop-step">1</span>Twoja praca / sparafrazowany tekst </div>] } 
        </label>
        <textarea className={`jsa-text-content${((inputType === InputTypes.TEXT) && ! (((textorfile === null)||!(textorfile === "TEXT"))&&(secondLabel === "true")))? 'checked' : ''}`}
                  value={content || ''}
                  disabled={inProgress || processing}
                  onChange={this.onInputTextChange}/>

     
  
      
      
      
    </div>;
  }
}

CompareText.propTypes = {
  sourceType: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  secondLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  source: PropTypes.object,
  updateSource: PropTypes.func,
  processing: PropTypes.bool,
  setSelectedOnly: PropTypes.func,
  selectedOnly: PropTypes.bool,
  inProgress: PropTypes.bool

}

CompareText.defaultProps = {
  sourceType: ComparisonSourceTypes.ORIGINAL,
  label: '',
  secondLabel: '',
  updateSource: () => {},
  setSelectedOnly: () => {},
  selectedOnly: false,
  processing: false

}

export default connect(
  ({originalSource, userSource,processing, inProgress, selectedOnly}, {sourceType = ComparisonSourceTypes.ORIGINAL}) => ({
    selectedOnly,
    inProgress,
    source: sourceType === ComparisonSourceTypes.ORIGINAL ? originalSource : userSource,
    processing
  }),
  {updateSource, setSelectedOnly}
)(CompareText);